import { render, staticRenderFns } from "./Iconterm.vue?vue&type=template&id=96b3601e&scoped=true&"
import script from "./Iconterm.vue?vue&type=script&lang=js&"
export * from "./Iconterm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b3601e",
  null
  
)

export default component.exports